// metadata/metaDataStore.ts
import { A } from "@adornis/base/env-info.js";
import { AdornisEntity } from "../entities/adornisEntity.js";
import { MetaTree } from "./metaTree.js";
var BaseQLMetadata = class {
  constructor() {
    this.queries = {};
    this.mutations = {};
    this.subscriptions = {};
    this.scalars = {};
    this.unions = {};
    this.errors = [];
    this.enums = {};
    this.entities = new MetaTree({
      type: () => AdornisEntity,
      _class: "AdornisEntity",
      fields: {},
      children: [],
      options: {}
    });
  }
};
var metaState = { sealed: false };
var baseqlMetaData = new BaseQLMetadata();
var getOperationDict = (opType) => opType === "query" ? baseqlMetaData.queries : opType === "mutation" ? baseqlMetaData.mutations : baseqlMetaData.subscriptions;
var allOperationDefinitions = () => ({
  ...baseqlMetaData.queries,
  ...baseqlMetaData.mutations,
  ...baseqlMetaData.subscriptions,
  // static dummy definition to allow introspection queries from the client
  __schema: {
    name: "__schema",
    options: {},
    arrayDepth: () => 0,
    middlewares: [],
    params: [],
    type: () => AdornisEntity
  }
});
var getOperationDefinition = (doc) => {
  const opDef = doc.definitions[0];
  if (!opDef || opDef.kind !== "OperationDefinition")
    throw new Error("no OperationDefinition node found");
  const selectedField = opDef.selectionSet.selections[0];
  if (!selectedField || selectedField.kind !== "Field")
    throw new Error("no Field node found in SelectionSet");
  const op = allOperationDefinitions()[selectedField.name.value];
  if (!op)
    throw new Error(`Could not find BaseQL metadata for operation with name ${selectedField.name.value}
  Did you forget to import an entity containing this operation before server start?`);
  return op;
};
if (A.isDevelopment && !A.isServiceWorker) {
  globalThis.baseqlMetaData = baseqlMetaData;
}
export {
  BaseQLMetadata,
  allOperationDefinitions,
  baseqlMetaData,
  getOperationDefinition,
  getOperationDict,
  metaState
};
